import { Box, Button, Modal, Stack, TextField, Typography, useTheme } from '@mui/material'
import React from 'react';
import { useQueryClient } from 'react-query';
import { useAuthContext } from '../../../context/AuthContext';
import { customAlert, notify } from '../../../components/notify';
import { sendOrderCfmServ } from '../../../services/source-service';
import { useState } from 'react';
import MailsTxtField from '../../../components/MailsTxtField';
import CtrlLabelTxtFieldInfo from '../../../components/CtrlLabelTxtFieldInfo';
import { formatDateWithJs, isNotEmpty } from '../../../utils/format';

function OrderCfmMdl({ modalOpen, handleModalClose, poData }) {
    const [formErrors, setFormErrors] = useState({});
    const { setLoadingScreen } = useAuthContext();
    const queryClient = useQueryClient();
    const theme = useTheme();
    const [emails, setEmails] = useState([]);
    const [selection, setSelection] = useState({ content: "" });


    useState(() => {
        if (!poData)
            return

        setSelection((e) => { return { ...e, content: poData?.orderCfmTemp ?? "" } });

        if (!poData?.mailToArr)
            return
        const arr = (poData?.mailToArr || []).map((i) => i?.username);
        setEmails([...arr])
    }, [poData])



    async function handleSubmit(e) {
        e.preventDefault();
        if (emails.length === 0) {
            notify("error", "At least one email should be entered!");
            return
        }
        const formData = new FormData(e.target);
        const inputObject = Object.fromEntries(formData);
        let errorsObj = validate(inputObject);
        setFormErrors(errorsObj);
        if (Object.keys(errorsObj).length > 0)
            return;
        setLoadingScreen(true);
        try {
            const payload = {
                poIdStrg: poData?.poIdStrg,
                toMail: emails.join(', '),
                content: inputObject?.content,
                expecDelDate: isNotEmpty(inputObject?.expecDelDate) ? inputObject?.expecDelDate : null,
                expecDelDateStrg: formatDateWithJs(inputObject?.expecDelDate)
            }
            const { message } = await sendOrderCfmServ(payload);
            notify("success", message);
            handleModalClose();
            queryClient.invalidateQueries();
        } catch (err) {
            console.log(err);
            customAlert(err);
        }
        setLoadingScreen(false);
    }

    function validate(values) {
        const errors = {};

        if (!values.content)
            errors.content = "Description is required!";

        if (!values.expecDelDate)
            errors.expecDelDate = "Expected Delivery Date is required!";

        return errors;
    };

    function handleValChange(e) {
        const { name, value } = e.target;
        setSelection((e) => { return { ...e, [name]: value } });
    }



    return (
        <Modal
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            {poData ? <form onSubmit={handleSubmit} >
                <Box sx={modalStyle}>
                    <Stack direction={'row'} justifyContent={"center"} mb={2} width={"100%"}>
                        <Typography sx={{ fontWeight: "bold", fontSize: 17, color: "rgba(0, 0, 0, 0.6)", mr: 1 }}>Send Order Confirmation</Typography>
                    </Stack>
                    <Stack gap={2} alignItems="center">
                        <MailsTxtField emails={emails} setEmails={setEmails} width={"100%"} title={"To"} />

                        <Stack width={"100%"}>
                            <CtrlLabelTxtFieldInfo value={selection.content} onChange={handleValChange} name="content" errMsg={formErrors?.content} title="Description *" width={"100%"} borderRadius={1}
                                rows={12} multiline={true} height={210} />
                            <Stack width={"100%"} alignItems={"end"}>
                                <Typography sx={{ color: "red", fontSize: 11 }}>
                                    *Use "<span style={{ fontWeight: 600 }}>@{'{'}Expected_Date{'}'}</span>" for the delivery date and "<span style={{ fontWeight: 600 }}>@{'{'}PO_LINK{'}'}</span>" for the Order Request link in the email.
                                </Typography>
                            </Stack>
                        </Stack>



                        <Stack direction={"row"} alignItems={"center"} gap={2} width={"100%"} justifyContent={"start"}>
                            <Typography sx={{ color: "rgba(0, 0, 0, 0.8)", fontWeight: 500, fontSize: 12 }}>
                                Expected Delivery Date * :
                            </Typography>
                            <TextField name='expecDelDate' type='date' size='small' error={formErrors?.expecDelDate && true} helperText={formErrors?.expecDelDate && formErrors?.expecDelDate}
                                sx={{ '& .MuiOutlinedInput-root': { fontSize: 12, width: 150, color: "rgba(0, 0, 0, 1)" } }} />
                        </Stack>
                        <Stack justifyContent={"flex-end"} direction={"row"} sx={{ mt: 1 }} width={"100%"} gap={2}>
                            <Button variant="text" sx={{ color: theme.palette.custom.btn, height: 30 }} onClick={handleModalClose}>  CANCEL</Button>
                            <Button variant="contained" type='submit'
                                sx={{ color: "white", bgcolor: theme.palette.custom.btn, height: 30 }}>
                                SEND</Button>
                        </Stack>
                    </Stack>
                </Box>
            </form> : <Typography component={'h1'}>Something went wrong</Typography>
            }
        </Modal>
    )
}

export default OrderCfmMdl;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "60vw",
    bgcolor: 'background.paper',
    border: '2px solid #ffff',
    boxShadow: 24,
    px: 4,
    py: 2,
    borderRadius: 2,
};


